export const BACKUPRESTORETABS = {
	BACKUP: "BACKUP",
	RESTORE: "RESTORE",
};

export interface ApplicationName {
	id: string;
	applicationName: string;
}
